import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    PageCategory,
    PageScope,
    providePageMeta,
} from '@app/router';

@NgModule()
export class NugetMetaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: NugetMetaModule,
            providers: [
                providePageMeta({
                    title: 'Packages',
                    translationKey: 'page_packages',
                    routerLink: '/packages',
                    sidebarSection: 'Management',
                    icon: 'archive',
                    permission: 'Packages.View',
                    type: 'Sidebar',
                    category: PageCategory.Tenant,
                    scope: PageScope.Global,
                    priority: 4,
                }),
                providePageMeta({
                    title: 'Libraries',
                    translationKey: 'page_libraries',
                    routerLink: '/libraries',
                    permission: 'Libraries.View',
                    icon: 'storage',
                    type: 'SubMenu',
                    parentRoute: '/packages',
                    category: PageCategory.Tenant,
                    scope: PageScope.Global,
                    priority: 3,
                }),
                providePageMeta({
                    title: 'Libraries',
                    translationKey: 'page_libraries',
                    routerLink: '/host/libraries',
                    icon: 'storage',
                    type: 'Sidebar',
                    category: PageCategory.Host,
                    scope: PageScope.Global,
                    priority: 2,
                }),
            ],
        };
    }
}
